import script from "./EditContactsSharePage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditContactsSharePage.vue?vue&type=script&setup=true&lang=js"

import "./EditContactsSharePage.vue?vue&type=style&index=0&id=42118583&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42118583"]])

export default __exports__